import { Injectable } from "@angular/core";
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { catchError, map, Observable } from "rxjs";
import { UnitModel } from "./unit.model";

const API_URL = environment.apiUrl

@Injectable({
  providedIn: 'root',
})
export class UnitService {
  constructor(private http: HttpClient) {}

  addUnit(unit: UnitModel) {
    return this.http
      .post(API_URL + '/Unit/CreateUnit', unit, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  getAllUnits(): Observable<UnitModel[]> {
    return this.http.get(API_URL + '/Unit/ReadUnits', {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }


}
